import reportEmployee from '@/api/report-employee'
import Branch from '@/api/branch'
import Employee from '@/api/employee'
import { baseState, baseMutations } from '@/store/mixins'
import moment from 'moment'

export const state = {
	...baseState,
	start_date: moment().startOf('month').format('DD-MM-YYYY'),
	end_date: moment().endOf('month').format('DD-MM-YYYY')
}

export const getters = {}

export const mutations = {
	...baseMutations,
	SET_START_DATE(state, date) {
		state.start_date = date
	},
	SET_END_DATE(state, date) {
		state.end_date = date
	}
}

export const actions = {
	//employee daily timescan
	dailyTimescan(context, attributes = {}) {
		return reportEmployee.dailyTimescan({
			params: Object.assign(
				{
					start_date: context.state.start_date,
					end_date: context.state.end_date
				},
				attributes
			)
		})
	},

	getBranch(context, attributes = {}) {
		return Branch.get({
			params: {
				fields: {
					setup_branch_profiles: 'branch_id,branch_name_en'
				},
				filter: {
					user_branches: 1
				},
				page: -1
			},
			headers: {
				'X-PERMISSION-ALLOW-CODE': context.rootGetters.permissionAllowCode
			}
		})
	},

	getEmployees(context, attributes = {}) {
		let params = {
			page: -1,
			fields: {
				setup_staff_information: 'staff_id,name_en,name_kh'
			},
			...attributes
		}
		return Employee.get({
			params: params,
			headers: {
				'X-PERMISSION-ALLOW-CODE': context.rootGetters.permissionAllowCode
			}
		})
	},
	getDepartment(context, data) {
		return reportEmployee.department(data);
	},

	// generate daily timescan as excel
	dailyTimescanExcel(context, data) {
		return reportEmployee.dailyTimescanExcel(
			Object.assign(
				{
					start_date: context.state.start_date,
					end_date: context.state.end_date
				},
				data
			)
		)
	}
}
